import {
  horizontalDrag,
  lazyLoad,
  resizeReducedAnimation,
  loadIn
} from 'utility';

import AOS from 'aos';
import 'aos/dist/aos.css';
import './utility/responsive';
import './utility/hamburger';
// import './utility/sidebar-links';
// import './utility/ga-form';
import './utility/anchor-fix';
import VendorScriptLoader from './utility/vendor-script-loader';
import numberCounter from './component/number-counter';
import ViewportFlexItems from "./utility/viewport-flex-items";
import './global/footer/menu.js'; import './global/form/datepicker-settings.js'; import './global/form/required-fix.js'; import './global/menu/navigation.js'; import './global/menu/post-slider.js'; import './global/modal/modal.js'; import './global/modal/redirect-modal.js'; import './global/page-links/page-links.js'; import './global/post-info/post-progress.js'; import './global/unlock/unlock.js'; // just run yarn

import './blocks/cta/cta';
import './blocks/accordion/accordion';
import './blocks/faqs/index.js';
// NOTE - this file includes js for all hero types. Hero Header 1 has a VueJS app for the animated text,
// which is loaded below in registerBlocks()
import './blocks/hero/hero-header';
import './blocks/hero/homepage-slide-video-block';

import './component/related-posts';
import Video from './component/video';
// import './easter-egg';

import './global';
import HomeSlidesWithVideo from './blocks/hero/homepage-slide-video-block';

/**
 * Code-splitting :: Blocks
 *
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  if (document.querySelector('.featured-success-story')) {

    import('./blocks/carousel/featured-success-story');
  }

  if (document.querySelector('.post-carousel')) {
    import ('~style/blocks/posts/_post-carousel.scss');
  }

  if (document.querySelector('.services-slider')) {
    import ('./blocks/carousel/services-slider');
  }

  if ( document.querySelector('.js-values-carousel-block') ) {
    import('./blocks/carousel/values-carousel').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.gated-content')) {
    import ('~style/blocks/gated-content/_gated-content.scss');
  }
  if (document.querySelector('.js-speakers-variant')) {
    import('~scripts/blocks/speakers/variant')
  }

  if ( document.querySelector('.js-speakers') ) {
    import('~scripts/blocks/speakers').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });
  }

  if ( document.querySelector('.js-agenda-table') ) {
    import('~scripts/blocks/agenda-table');
  }

  if (document.querySelector('.gated-content-one')) {
    import ('~style/blocks/gated-content/_gated-content-1.scss');
  }

  if (document.querySelector('.gated-content-two')) {
    import ('~style/blocks/gated-content/_gated-content-2.scss');
  }

  if (document.querySelector('.two-col-img')) {
    import ('~style/blocks/text-and/_two-col-img.scss');
  }

  if (document.querySelector('.intro-icon')) {
    VendorScriptLoader.outputVendorScriptTag('vendor-lottie-js');
    import ('~style/blocks/intro/_intro-icon.scss').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });
  }

  if (document.querySelector('.impact')) {
    import ('~style/blocks/impact/_impact.scss');
  }

  if ( document.querySelector('.cta')) {
    import ('~style/blocks/cta/_cta.scss');
  }

  if ( document.querySelector( '.image-case-study')) {
    import ('~style/blocks/image-case-study/_image-case-study.scss');
  }

  if ( document.querySelector('.cta-text')) {
    import ('~style/blocks/cta/_cta-text.scss');
  }

  if ( document.querySelector('.masonry-grid')) {
    import ('~style/blocks/masonry-grid/_masonry-grid.scss');

    import ('~scripts/blocks/masonry-grid');
  }

  if ( document.querySelector('.tile-grid')) {
    import ('~style/blocks/tile-grid/_tile-grid.scss').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });
  }

  if ( document.querySelector('.feature-cta')) {
    import ('~style/blocks/cta/_feature-cta.scss');
  }

  if ( document.querySelector('.heading')) {
    import ('~style/blocks/global/_heading.scss');
  }

  if ( document.querySelector('.aparagraph__container')) {
    import ('~style/blocks/global/_aparagraph.scss');
  }

  if ( document.querySelector('.button-grid')) {
    import ('~style/blocks/buttons/_button-grid.scss');
  }

  if ( document.querySelector('.num-two-col') ) {
    import ('~style/blocks/text-and/_numbered-two-column-text.scss');
  }

  if ( document.querySelector('.case-study-intro')) {
    import ('~style/blocks/intro/_case-study-intro.scss');
  }

  if ( document.querySelector('.quote')) {
    import ('~style/components/quote/_quote.scss');
  }

  if ( document.querySelector('.statistics')) {
    import ('~style/components/statistics/_statistics.scss').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });
    const defaultStats = new numberCounter();
    defaultStats.init()
  }

  if ( document.querySelector('.event-single')) {
    import ('~style/blocks/events/_event-meta.scss');
    import ('~style/blocks/events/_event-clocks.scss');
    import ('~style/blocks/events/_event-footer.scss');
  }
 
  if ( document.querySelector('.single-evt')) {
    import ('~scripts/component/event');
  }

  if ( document.querySelector('.image')) {
    import ('~style/blocks/global/_image.scss');
  }

  if ( document.querySelector('.three-stats')) {
    import ('~style/blocks/stats/_three-stats.scss');
  }

  if ( document.querySelector('.js-courses') ) {
    import ('~style/blocks/courses/_courses.scss');
  }

  if ( document.querySelector('.cta-video')) {
    import('./blocks/cta/cta');

    import ('~style/blocks/cta/_cta-video.scss');
  }

  if ( document.querySelector('.columns-block')) {
    import('~style/blocks/columns-block/_columns-block.scss');
  }

  if ( document.querySelector('.events-feed') ) {
    import('./blocks/feeds/event/event-sidebar');
  }

  if ( document.querySelector('.js-icon-count-up') ) {
    import('./blocks/icon-count-up');
  }
  
  if ( document.querySelector('.js-image') ) {
    VendorScriptLoader.outputVendorScriptTag('vendor-lottie-js');
  }

  if ( document.querySelector('.horizontal-nav') ) {
    // console.log('Loading horizontal nav');

    import ('~style/blocks/horizontal-nav/_horizontal-nav.scss');

    import('./blocks/horizontal-nav/horizontal-nav');
  }

  if ( document.querySelector('.standalone')) {
    import ('~style/blocks/buttons/_standalone-button.scss');
  }

  if (document.querySelector('.testimonial')) {
    import ('~style/blocks/testimonials/_testimonial.scss');
  }

  if (document.querySelector('.fam')) {
    import ('~style/blocks/form/_fam.scss');
  }

  if ( document.querySelector('.posts-stacked')) {
    import ('~style/blocks/posts/_posts-stacked.scss');
  }

  if ( document.querySelector('.article-intro')) {
    import ('~style/blocks/intro/article-intro.scss');
  }

  if ( document.querySelector('.hover-accordion') ) {
    import('~style/blocks/accordion/_accordion.scss' );
  }

  if ( document.querySelector('.hover-faqs') ) {
    import('~style/blocks/faqs/_faqs.scss' );
  }

  if ( document.querySelector('.paragraph')) {
    import('~style/blocks/global/_paragraph.scss');
  }
  
  if ( document.querySelector('.customisable-button')) {
    import('~style/blocks/buttons/_customisable-button.scss');
  }

  if ( document.querySelector('.carousel--impact') ) {
    import('./blocks/impact/impact-feature-carousel');
  }

  if ( document.querySelector('.carousel--large') || document.querySelector('.carousel')) {
    import('~style/blocks/carousel/_carousel.scss');
  }

  if ( document.querySelector('.logos') ) {
 
    import('./blocks/logos/logo-static');
  }

  if ( document.querySelector('.js-logo-slider') ) {
    import('./blocks/logos/logo-slider');
  }

  if ( document.querySelector('.link-list') ) {
    import('~style/blocks/link/_link-list.scss');
  }
 
  if ( document.querySelector('.post-carousel--slider') ) {
    import('./blocks/posts/case-study-carousel');
  }

  if ( document.querySelector('.horizontal-posts') ) {
    import ('~style/blocks/posts/_horizontal-posts.scss');

    import('./blocks/posts/horizontal-scroll');
  }

  if ( document.querySelector('.case-study-detail-carousel')) {
    import ('~style/blocks/posts/_case-study-detail.scss');

    import ('./blocks/posts/case-study-detail');
  }

  if ( document.querySelector('.block__text') ) {
    import('./blocks/text-and-inner/numbered-icon-text-columned');
  }

  if ( document.querySelector('.double-logo-carousel') ) {
    import ('~style/blocks/double-logo-carousel/_double-logo-carousel.scss');
  }

  if ( document.querySelector('.two-col-bullet')) {
    import ('~style/blocks/two-col-bullet/_two-col-bullet.scss');
  }

  if ( document.querySelector('.standout-text__content') ) {
    // Imported via _blocks.scss to avoid FOUT (Flash of unstyled text/content)
    // import ('~style/blocks/text-and/_standout-text.scss');

    import('./blocks/text-and-inner/standout-text');
  }

  if ( document.querySelector('.icon-text')) {
    import ('~style/blocks/text-and/_icon-text.scss');
  }

  if ( document.querySelector('.comparison-points')) {
    import ('~style/blocks/comparison-points/_comparison-points.scss');
  }

  if ( document.querySelector('.text-and-image-simple')) {
    import ('~style/blocks/text-and-simple/_text-and-simple.scss');
  }

  if ( document.querySelector('.column-tiles')) {
    import ('~style/blocks/column-tiles/_column-tiles.scss');
  }

  if ( document.querySelector('.standalone-form')) {
    import ('~style/blocks/form/_standalone-form.scss');
  }

  if ( document.querySelector('.contact-modal')) {
    import ('~style/blocks/modal/_contact-modal.scss');
  }

  if ( document.querySelector('.grid')) {
    import ('~style/blocks/utility/_grid.scss');
  }

  if ( document.querySelector('.quote-block')) {
    import ('~style/blocks/quote/_quote.scss').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });
  }

  if ( document.querySelector('.tam')) {
    import ('~style/blocks/text-and/_tam.scss').then(() => {
      import('./blocks/text-and-inner/text-and-inner');

    });
  }

  if ( document.querySelector('.tam__block') ) {
  }

  if ( document.querySelector('.js-gallery-mason-grid') ) {
    import('~scripts/blocks/gallery/gallery-mason-grid').then(component => {
      component.default.init();
    });
  }

  if ( document.querySelector('.js-icon-descriptions') ) {
    import ('~style/blocks/icon-descriptions/index.scss');
  }

  if ( document.querySelector('.js-podcast-players') ) {
    import ('~style/blocks/podcast-players/index.scss');
  }

  if (document.querySelector('.proposition-tiles-block')) {
    import('~style/blocks/proposition-tiles/_proposition-tiles.scss');
  }

    if (document.querySelector('.js-service-pillars-block')) {
        import('~scripts/blocks/service-pillars/service-pillars.js');
  }

  if (document.querySelector('.partner-tiles-block')) {
    import('~style/blocks/partner-tiles/_partner-tiles.scss');
  }

  if (document.querySelector('.call-to-action-block')) {
    import('~style/blocks/call-to-action/_call-to-action.scss');
  }

  if ( document.querySelector('.js-testimonial-slider-block') ) {
    import('~scripts/blocks/carousel/testimonial-slider').then(component => {
      const TestimonialSlider = component.default;
      TestimonialSlider.init();
    });
  }

  if ( document.querySelector('.js-three-column-tiles') ) {
    import('~scripts/blocks/three-column-tiles').then(component => {
      const ThreeColumnTilesSlider = component.default;
      ThreeColumnTilesSlider.init();
    });
  }

  if ( document.querySelector('.js-solutions-tab') ) {
    import('~scripts/blocks/solutions-tab');
  }

  if ( document.querySelector('.js-lottie-file') ) {
    VendorScriptLoader.outputVendorScriptTag('vendor-lottie-js');

    document.addEventListener('vendor-lottie-js:loaded', () => {
      import('~scripts/component/lottie-file');

    });
  }

  if ( document.querySelector('.js-centred-video') ) {
    import('~scripts/blocks/centred-video').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });
  }

  if ( document.querySelector('.tabbed-reading-list') ) {
    import('~scripts/blocks/tabbed-reading-list');
  }

  if ( document.querySelector('.text-mixed-content') ) {
    import('~scripts/blocks/text-mixed-content').then(() => {
      document.dispatchEvent(new Event("aos-refresh"));
    });

    Video.init();
  }

  // VueJS app
  if ( document.getElementById('event-clocks-app') !== null ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('./blocks/events/event-clocks');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-moment']);
  }

  if ( document.querySelector('.animated-cta') !== null) {
    import ('~style/blocks/cta/_animated-cta.scss');

    document.addEventListener('vendor-vue:loaded', () => {
      import ('./blocks/cta/animated-cta.js');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  }

  // VueJS app
  if ( document.querySelector('.hero-header-1') !== null ) {
    // Imported via _blocks.scss to avoid FOUT (Flash of unstyled text/content)
    // import('~style/blocks/hero/_homepage-header-1.scss');

    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-vue:loaded', () => {
      import('./blocks/hero/hero-header-animated-text');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  }

  if (document.querySelector('.js-click-down')) {
    import ('./blocks/hero/homepage-video-header');
  }

  // VueJS app
  if ( document.querySelector('.feed-v-container') !== null ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('./blocks/feeds');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-moment']);
  }

  // VueJS app
  if ( document.querySelector('#feed-v2') ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('./blocks/feed-v2');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-vuex', 'vendor-moment']);
  }

  if ( document.querySelector('#careers-block') ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('vendor-vue:loaded', () => {
      import('~scripts/blocks/careers');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  }

  if ( document.querySelector('.js-video-autoplay') ) {
    import('~scripts/blocks/video/video-autoplay').then(component => {
      
      component.default.init();
    });
  }

  if (document.querySelector('.js-logo-ribbon')) {
    import('./blocks/logo-ribbon');
  }

  if ( document.querySelector('.js-team-profiles') ) {
    import('./blocks/team-profiles');
  }

  if ( document.querySelector('.js-faqs-block-accordion') ) {
    import('./blocks/faqs');
  }

  if ( document.querySelector('#featured-topic-article-list') ) {
    import('./blocks/featured-topic-article-list');
  }
}


/**
 * Code-splitting :: Components
 *
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerComponents() {
  // VueJS app
  if ( document.getElementById('benchmark-calc-container') ) {
    // Load CSS


    import ('~style/templates/benchmark-calculator/_benchmark-calculator.scss')

    import ('~style/blocks/horizontal-nav/_horizontal-nav.scss');

    import('./blocks/cta/cta');

    import ('~style/blocks/cta/_cta.scss')

    import('./blocks/horizontal-nav/horizontal-nav');

    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-vue:loaded', () => {
      import('./component/benchmark-calculator');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  }

  if ( document.querySelectorAll('.clock').length > 0 ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-moment:loaded', () => {
      import('./component/clock');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-moment');
  }

  if ( document.querySelectorAll('.file-upload__input') ) {
    import('./component/job-details');
  }

  // Search Overlay
  if ( document.querySelector('.js-search-overlay') ) {
    import('./component/search-overlay').then(component => {
      component.default.init();
      console.log('imported');
    });
  }
}

document.addEventListener('DOMContentLoaded', registerBlocks);
document.addEventListener('DOMContentLoaded', registerComponents);
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('body').classList.contains('language-de')) {
    
    document.addEventListener('vendor-hyphens:loaded', () => {
      import('./utility/hyphens');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-hypher');
  }

  AOS.init();

  // Initialises positioning fix for elements on mobile browsers
  ViewportFlexItems.init();

  // Initialises video slide header
  if (document.querySelector('.js-home-slide-video-block')) {
    HomeSlidesWithVideo.init();
  }
});

/**
 * Makes AOS calculate the position on targeted elements.
 *
 * You will need to trigger this event from inside any code-split file as AOS needs to get
 * the correct position of elements after they've been styled.
 *
 * i.e. document.dispatchEvent(new Event("aos-refresh"));
 */
document.addEventListener("aos-refresh", () => {
  // Timeout required to make up for the time it takes for the browser to render the styles on the page
  setTimeout(() => {
    AOS.refresh();
  }, 1000);
});

document.addEventListener(
  "video:loaded",
  (e) =>
    e.target.matches(".cta-video__video iframe") &&
    setTimeout(
      () => e.target.closest(".cta-video").classList.add("cta-video--loaded"),
      1000
    )
);


horizontalDrag('.draggable', 2);
lazyLoad();
loadIn(['DOMContentLoaded', 'vue:loaded', 'vue:updated']);
resizeReducedAnimation();